import { createApp } from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import "amfe-flexible";
import "default-passive-events";
import "vant/es/toast/style";
import "animate.css";
import "./assets/scss/base.scss";
import "./assets/scss/common.scss";
import "./assets/scss/vant.scss";
import { Icon } from 'vant';
import { ImagePreview } from 'vant';
const app = createApp(App);
app.use(router).use(store).use(ImagePreview).use(Icon).mount("#app");
